module.exports = __webpack_public_path__ + "static/img/icon-00.237e9e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/icon-00.jpg
// module id = oBVC
// module chunks = 1